document.addEventListener('DOMContentLoaded', ()=> {
    let inputWithLabel = document.querySelectorAll('.input');
    inputWithLabel.forEach(item => {
        let inputLabel = item.querySelector('.input__label'),
            inputText = item.querySelector('.input__text');
        if(inputLabel) {
            inputLabel.classList.add('_hide');
            inputText.setAttribute('placeholder', inputLabel.textContent)
            inputText.onfocus = function () {
                inputLabel.classList.remove('_hide');
                inputText.removeAttribute('placeholder')
            }

            inputText.onblur = function () {
                if(inputText.value.length === 0) {
                    inputLabel.classList.add('_hide');
                    inputText.setAttribute('placeholder', inputLabel.textContent)
                }
            }
        }
    })
})